import PathConstants from '../path-contants'
import { EnrollmentCategory } from '@/domain/models/content/enrollment-category'

const getCategoryGroupPaths = (): PathConstants.RoutesProps => {
  return EnrollmentCategory.getGroups().reduce((acc, group) => {
    return {
      ...acc,
      [`CATEGORY_GROUP_${group.name.toUpperCase()}`]: {
        value: `/category/group/${group.name.toLocaleLowerCase()}`,
        name: group.name.toLocaleLowerCase(),
        title: group.title
      }
    }
  }, {})
}

export default getCategoryGroupPaths
